const n = {
  name: "Document",
  dimensions: { width: 28, height: 41 },
  content: `
    <g fill="currentColor" stroke="none">
        <path d="M2 37.0029V2.00293H15C15.55 2.00293 16 2.45293 16 3.00293V10.0029C16 11.1029 16.9 12.0029 18 12.0029H25C25.55 12.0029 26 12.4529 26 13.0029V38.0029H3C2.45 38.0029 2 37.5529 2 37.0029ZM18 3.41293L24.59 10.0029H19C18.45 10.0029 18 9.55293 18 9.00293V3.41293ZM27.41 10.0029L18 0.59293C17.62 0.21293 17.12 0.00292969 16.59 0.00292969H2C0.9 0.00292969 0 0.90293 0 2.00293V38.0029C0 39.1029 0.9 40.0029 2 40.0029H26C27.1 40.0029 28 39.1029 28 38.0029V11.4129C28 10.8829 27.79 10.3829 27.41 10.0029Z"/>
    </g>
  `
};
export {
  n as Document
};
